import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefereeService {

  constructor(private http: HttpClient) { }

  saveReferee(payload){
    return this.http.post<any>(`${environment.apiUrl}/v1/referees`, payload)
  }

  getReferees(){
    return this.http.get<any>(`${environment.apiUrl}/v1/referees`)
  }

  updateReferee(payload){
    return this.http.put<any>(`${environment.apiUrl}/v1/referees`, payload)
  }

  deleteReferee(id){
    return this.http.delete<any>(`${environment.apiUrl}/v1/referees/`+id)
  }
}
